export interface ILocalisedValue {
  nameNl: string;
  nameFr: string;
  nameEn: string;
  nameDe: string;
}

export function getLocalisedName(val: Partial<ILocalisedValue> & Pick<ILocalisedValue, 'nameNl'>, lang: string) {
  switch (lang.trim().toUpperCase()) {
    case 'NL':
      return val.nameNl;
    case 'DE':
      return val.nameDe ?? val.nameNl;
    case 'FR':
      return val.nameFr ?? val.nameNl;
    default:
      return val.nameEn ?? val.nameNl;
  }
}
